import React, { useState, useEffect } from 'react';
import { Chart, InfoTile } from '..';
import { connect, useDispatch } from 'react-redux';
import { RootState } from 'redux/root.reducer';
import { CFCProps, DashboardDBYDStatsResponse } from 'types';
import { addAlert } from 'redux/alerts/actions';

export const getWaitTimeMin = (waittime?: number) => {
  return typeof waittime === 'number' ? (waittime / 60).toFixed(1) : '0';
};

export const AOInfos: React.FC<Props> = ({
  rawDBYDStats,
  startDate,
  range,
  organisationName,
  isAADBYD = false
}) => {
  const [isLoadingStat, setIsLoadingStat] = useState<boolean>(true);
  const dispatch = useDispatch();
  const [dbydStats, setDbydStats] = useState<DashboardDBYDStatsResponse>();

  useEffect(() => {
    if (rawDBYDStats) {
      if (typeof rawDBYDStats === 'string') {
        dispatch(addAlert('dashbaord-alert', 'error', 'Error', rawDBYDStats));
      } else {
        setDbydStats(rawDBYDStats);
        setIsLoadingStat(false);
      }
    } else {
      setDbydStats(undefined);
      setIsLoadingStat(true);
    }
  }, [rawDBYDStats, dispatch]);

  return (
    <>
      <div className="dashboard-content-info-container">
        <InfoTile
          isLoading={isLoadingStat}
          invert={true}
          title="Enquiries"
          value={dbydStats?.DBYDEnquiries.total || 0}
        />
        <InfoTile
          isLoading={isLoadingStat}
          title="Referrals made"
          value={dbydStats?.referralCount || 0}
        />
      </div>
      <Chart
        title={
          isAADBYD ? 'All BYDA enquiries' : `All ${organisationName} enquiries`
        }
        isLoading={isLoadingStat}
        range={range}
        chartData={dbydStats?.DBYDEnquiries}
        startDate={startDate}
      />
      <div className="dashboard-content-info-container single">
        <InfoTile
          isLoading={isLoadingStat}
          title="Unique users"
          value={dbydStats?.userCount || 0}
        />
      </div>
    </>
  );
};

type OwnProps = {
  organisationName?: string;
  isAADBYD: boolean;
  startDate: string;
  range: string;
};

const mapStateToProps = ({ dashboardCache }: RootState) => ({
  rawDBYDStats: dashboardCache.dbydStats
});

const connector = connect(mapStateToProps);

type Props = CFCProps<typeof connector> & OwnProps;

export default React.memo(connector(AOInfos));
